import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import DryBeansProduct from 'models/DryBeansProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { sizeOptions, packagingInitialState } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Switch from 'react-switch'

const DryBeansPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSelect, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        BeanPeaLentilSize,
        Organic,
      } = current
      setPackaging({
        category,
        subCategory,
        BeanPeaLentilSize: {
          value: BeanPeaLentilSize || '',
          label: BeanPeaLentilSize.length > 0 ? BeanPeaLentilSize : 'Size',
        },
        Organic: Organic ?? false,
      })
    } else if (!updating) {
      setCurrent(DryBeansProduct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={sizeOptions}
            name="BeanPeaLentilSize"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Size'}
            onChange={([selected]) => {
              setSelect(selected, 'BeanPeaLentilSize')
              return selected
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="BeanPeaLentilSize"
              message={'⚠ Bean size is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
      </Col>
      <Col xs={6}>
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.Organic}
        />
      </Col>
    </Row>
  )
}

export default DryBeansPackage
